<template>
    <div class="act-group-buy-vip">
        <div class="act-content">
            <div class="scroller">
                <div class="whole-bg" :class="{ 'has-group-info': hasValidGroupInfo }">
                    <div class="group-info" v-if="hasValidGroupInfo">
                        <template v-if="showGroupIng">
                            <div class="cnt">
                                <group-goods-info :group-vip-goods-info="groupVipGoodsInfo"></group-goods-info>
                                <div class="user-info">
                                    <div class="title">开通会员 免费畅玩</div>
                                    <div class="price-sec">
                                        <span class="sp1">拼团优惠</span>
                                        <span class="sp2">¥</span>
                                        <span class="sp3">{{ groupVipGoodsInfo.group_price }}</span>
                                        <span class="sp4">¥&nbsp;{{ groupVipGoodsInfo.showOriginPrice ? groupVipGoodsInfo.original_price : groupVipGoodsInfo.current_price }}</span>
                                    </div>
                                    <div class="line">
                                        <div class="discount">
                                            <div class="dv1">已优惠</div>
                                            <div class="dv2 ellipsis">
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ subsidyPrice(groupVipGoodsInfo) }}</i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="countdown">
                                        <span class="sp1">{{ countdownStr.slice(0, 2) }}</span>
                                        <span class="sp2">:</span>
                                        <span class="sp1">{{ countdownStr.slice(2, 4) }}</span>
                                        <span class="sp2">:</span>
                                        <span class="sp1">{{ countdownStr.slice(4) }}</span>
                                        <span class="sp3">后结束</span>
                                    </div>
                                </div>
                                <div class="invite-info">
                                    <div class="item1">
                                        <img v-if="avatar(1)" :src="avatar(1)" alt="用户头像" />
                                        <div class="icon">团长</div>
                                    </div>
                                    <div class="item2">
                                        <img v-if="avatar(2)" :src="avatar(2)" alt="用户头像" />
                                    </div>
                                </div>
                            </div>
                            <template v-if="userGroupInfo?.latest_main?.order_status === 1">
                                <div class="share-btn" v-if="leftTime > 0 && !showShareLink" @click="handlerClickShareBtn">生成分享链接</div>
                                <div class="share-link-section" v-if="showShareLink">
                                    <div class="link-dv">{{ shareLink }}</div>
                                    <div class="copy-btn" @click="copyLink">复制</div>
                                </div>
                            </template>
                        </template>
                        <template v-else-if="lastGroupSucc">
                            <div class="cnt succ">
                                <group-goods-info :group-vip-goods-info="groupVipGoodsInfo"></group-goods-info>
                                <div class="group-succ">
                                    <div class="text text1">恭喜你与好友<span>拼团成功</span>，</div>
                                    <div class="text">立即开始游戏吧！</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="cnt fail">
                                <group-goods-info :group-vip-goods-info="groupVipGoodsInfo"></group-goods-info>
                                <div class="group-fail">
                                    <div class="text text1"><span class="icon"></span>很遗憾您的上轮拼团失败，可重新开团！</div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="vip-goods-wrap">
                        <div class="item" :class="[`${showVipGoodsIcon(item)}`]" v-for="(item, index) in vipGoodsList" :key="item.id">
                            <div class="icon" v-if="showVipGoodsIcon(item) === 'vip1'"></div>
                            <div class="inner">
                                <div class="dv1">
                                    {{ item.name }}
                                </div>
                                <div class="dv2">
                                    <!-- 优先按照"原价展示渠道"逻辑展示价格 -->
                                    <template v-if="item.showOriginPrice">
                                        <span class="sp1">
                                            <i class="i0">仅售</i>
                                            <i class="i1">¥</i>
                                            <i class="i2">{{ item.original_price }}</i>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="sp1">
                                            <i class="i0">仅售</i>
                                            <i class="i1">¥</i>
                                            <i class="i2">{{ item.current_price }}</i>
                                        </span>
                                        <span class="sp2" v-if="item.original_price * 100 !== item.current_price * 100 && item.original_price * 100 > item.current_price * 100">
                                            <i>原价</i>
                                            <i>{{ item.original_price }}</i>
                                        </span>
                                    </template>
                                </div>
                                <div class="dv4">全场游戏免费畅玩尊享{{ item.name }}</div>
                            </div>
                            <div class="buy-btn-sec">
                                <div class="lf-btn" v-throttle="[() => buy(1, item), 'click', 1000]">直接买</div>
                                <div class="rg-btn" v-throttle="[() => buy(2, item), 'click', 1000]">
                                    <span class="sp1">¥</span>
                                    <span class="sp2 ellipsis">{{ item.group_price }}</span>
                                    <span class="sp3">2人拼团</span>
                                    <div class="right-top">
                                        <span class="ellipsis">已补{{ subsidyPrice(item) }}元</span>
                                    </div>
                                    <template>
                                        <template v-if="index === 0">
                                            <div class="bottom-text">即将售罄</div>
                                        </template>
                                        <template v-else-if="index === 1">
                                            <div class="bottom-text white-color">库存：247</div>
                                        </template>
                                        <template v-else-if="index === 2">
                                            <div class="bottom-text white-color">库存：140</div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="activity-rules">
                        <div class="rules-title">活动规则</div>
                        <div class="divide-line"></div>
                        <div class="rules-cnt">
                            <div class="one-level">特别提醒：</div>
                            <div class="two-level"><span class="icon"></span>参与活动前，请仔细阅读活动规则的各个条款，用户参与本活动即视为已充分阅读、理解本活动规则，并自愿受活动规则的约束。</div>
                        </div>
                        <div class="rules-cnt">
                            <div class="one-level">规则明细：</div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">活动期间所有用户每天不限制开团次数，但只能成功达成一次活动拼团。任意档位会员套餐拼团成功后即视为达成拼团，不可再参与其他档位活动。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">拼团活动因超时未拼成、商品售罄等原因取消时，开团人和已邀请好友的订单均会自动退款，退款将于3天内原路退回。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">活动动时间为每日00:00-24:00，且成团有效期为24小时，开团人需在规定时间内邀请对应数量且满足参团要求的好友完成参团。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">具体可购买商品、优惠价格与库存信息以实际展示为准，若所有可拼团商品售罄时用户仍未成团，系统会自动取消未成团的订单。 拼团活动因超时未拼成、商品售罄等原因取消时，开团人和已邀请好友的订单均会自动退款，退款将于3天内原路退回。</div>
                            </div>
                        </div>
                        <div class="rules-cnt">
                            <div class="one-level">注意事项：</div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">活动期间如出现不可抗力或情势变更，包括但不限于重大灾害事件、黑客攻击、系统故障、活动受政府机关指令需停止举办或调整的，活动举办方可依据相关法律法规调整/暂停或提前终止活动。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">用户不得使用任何外挂、插件以及其他破坏活动规则、违背活动公平原则的方式参与本次活动（如批量注册、恶意购买、虚假分享、倒买倒卖、虚假交易等），否则活动举办方有权取消用户参与活动资格，追回已经领取或者使用的优惠权益，并在必要时取消后续参与任意活动的权利，同时追究法律责任。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">若市场环境、参与情况变动，活动举办方将对活动参与时间与活动规则进行调整，请以页面展示的最新规则为准。</div>
                            </div>
                            <div class="two-level">
                                <div class="icon"></div>
                                <div class="dv">如您在使用我方产品过程中遇到任何问题，请咨询客服。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Decimal from 'decimal.js'
import config from '@/http/config'
import { getCookieToken, canPlayGame } from '@/utils/auth'
import { getVipShopList } from '@/http/api/vip'
import { mapState } from 'vuex'
import { getUserGroupInfo } from '@/http/api/activity'
import { formatTime2 } from '@/utils/date'
import GroupGoodsInfo from './GroupGoodsInfo.vue'

export default {
    name: 'ActGroupBuyVip',
    components: {
        GroupGoodsInfo
    },
    data() {
        return {
            // 订单处于这些状态，不能再开团
            orderStatus: [1, 2, 3, 4, 5, 6],
            vipGoodsList: [],
            vipGoodsQuery: {
                page: 1,
                size: 3,
                is_group: 1,
                channel: 'pintuan' // 把渠道固定
            },
            userGroupInfo: {}, // 用户的拼团信息
            type: -1, // 1、直接购买 2、拼团购买
            chooseGoods: {},
            defautlAvatar: require('@/assets/default.png'),
            moreDefautlAvatar: require('@/assets/dialog/more-join-avatar.png'),
            leftTime: 0, // 拼团剩余时间
            countdownStr: '000000',
            showShareLink: false,
            queryGroupInfoTimes: 0,
            channel: this.$Utils.getNowChannel()
        }
    },
    computed: {
        ...mapState(['userInfo', 'serverTime', 'authInfo', 'authConfig']),
        avatar: function () {
            return (type) => {
                // type 1--开团的人头像 2--参团的人头像（存在多个参团人）
                const joinUserInfoList = this.userGroupInfo?.latest_main?.join_list?.filter((v) => this.orderStatus.indexOf(v.order_status)) || []
                // 没有参团人直接返回空或者有参团人订单状态不符合
                if (type === 2 && !joinUserInfoList.length) {
                    return ''
                }
                let avatar = ''
                if (type === 1) {
                    avatar = this.userGroupInfo.latest_main?.avatar
                } else if (joinUserInfoList.legnth === 1) {
                    avatar = joinUserInfoList[0].avatar
                }

                if (!avatar) {
                    if (joinUserInfoList.legnth > 1) {
                        return this.moreDefautlAvatar
                    }
                    return this.defautlAvatar
                } else if (avatar.indexOf('thirdwx.qlogo.cn') > -1) {
                    return avatar
                } else {
                    return config.PREVIEW_DOMAIN + avatar
                }
            }
        },
        showVipGoodsIcon() {
            return (item) => {
                let className = ''
                if (!item.name) {
                    className = ''
                } else if (item.name.indexOf('永久会员') > -1) {
                    className = 'vip1'
                } else if (item.name.indexOf('365天会员') > -1) {
                    className = 'vip2'
                } else if (item.name.indexOf('30天会员') > -1) {
                    className = 'vip3'
                }
                return className
            }
        },
        subsidyPrice() {
            return (item) => {
                if (!item.id) {
                    return 0
                }
                const payPrice = item.showOriginPrice ? item.original_price : item.current_price
                return Math.abs(new Decimal(payPrice).minus(new Decimal(item.group_price)).toNumber())
            }
        },
        // 拼团里面的商品信息
        groupVipGoodsInfo() {
            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
            const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
            if (this.showGroupIng) {
                //  拼团中
                return latest_main.goods_info
            } else if (this.lastGroupSucc) {
                // 拼团成功
                if (this.orderStatus.indexOf(latest_main.order_status) > -1) {
                    return latest_main.goods_info
                } else if (this.orderStatus.indexOf(hasJoinInfo.order_status) > -1) {
                    return hasJoinInfo.goods_info
                }
            } else {
                // 拼团失败
                if (latest_main.goods_info.id && latest_join.goods_info.id) {
                    // 优先展示最新参团失败的信息
                    if (+new Date(latest_main.start_time) > +new Date(latest_join.start_time)) {
                        return latest_main.goods_info
                    } else {
                        return latest_join.goods_info
                    }
                } else if (latest_main.goods_info.id) {
                    return latest_main.goods_info
                } else if (latest_join.goods_info?.id) {
                    return latest_join.goods_info
                }
            }
            return {}
        },
        // 是否含有有效的团信息
        hasValidGroupInfo() {
            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
            if (latest_main.id) {
                return true
            } else {
                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                return hasJoinInfo.id
            }
        },
        // 开团人是否可以再次开团
        canCreateGroupVipOrder() {
            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
            // 开团信息中显示是拼团中、拼团成功并且订单状态在this.orderStatus中
            if ((latest_main.status === 1 || latest_main.status === 2) && this.orderStatus.indexOf(latest_main.order_status) > -1) {
                return false
            } else {
                // 参信息中主团显示是拼团中、拼团成功，并且参团人的订单状态在this.orderStatus中
                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                if ((latest_join.status === 1 || latest_join.status === 2) && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1) {
                    return false
                } else {
                    return true
                }
            }
        },
        // 分享链接
        shareLink() {
            const group_id = this.userGroupInfo?.latest_main?.id || 0
            return `${config.BOX_WEBSITE_DOMAIN}/group?group_id=${group_id} 【仅剩1个名额，一起团${this.groupVipGoodsInfo.name}免费畅玩，2人成团到手价${this.groupVipGoodsInfo.group_price}元】`
        },
        // 是否展示拼团中的信息
        showGroupIng() {
            const { latest_main = {} } = this.userGroupInfo
            const { status, order_status } = latest_main
            // 拼团状态处于拼团中并且订单状态在this.orderStatus中
            return status === 1 && this.orderStatus.indexOf(order_status) > -1
        },
        // 上次拼团是否成功
        lastGroupSucc() {
            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
            if (latest_main.status === 2 && this.orderStatus.indexOf(latest_main.order_status) > -1) {
                return true
            } else {
                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                if (latest_join.status === 2 && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1) {
                    return true
                } else {
                    return false
                }
            }
        }
    },
    watch: {
        userInfo: {
            deep: true,
            handler(newVal) {
                if (newVal.id) {
                    this.getUserGroupInfo()
                }
            }
        },
        serverTime: {
            immediate: true,
            handler(newVal) {
                const { latest_main = {} } = this.userGroupInfo
                const { start_time, expire_time } = latest_main
                if (start_time && expire_time) {
                    this.leftTime = Math.ceil((+new Date(expire_time) - newVal * 1000) / 1000)
                    // 倒计时多加5分钟，因为订单创建后，二维码有5分钟的有效期
                    const showTime = Math.max(0, this.leftTime + 5 * 60)
                    this.countdownStr = formatTime2(showTime)
                }
            }
        }
    },
    beforeDestroy() {
        this.$EventBus.$off('update-group-info')
        clearTimeout(this.queryGroupInfoTimeTd)
    },
    mounted() {
        this.getUserGroupInfo()
        this.getVipGoodsData()
        this.$EventBus.$on('update-group-info', (payload) => {
            this.userGroupInfo = payload
        })
    },
    methods: {
        // 获取用户的参团信息
        getUserGroupInfo() {
            if (!getCookieToken()) {
                return
            }

            clearTimeout(this.queryGroupInfoTimeTd)
            let timeCell = 1000
            this.queryGroupInfoTimes++

            // 根据查询的次数
            if (this.queryGroupInfoTimes < 60) {
                timeCell = 1000
            } else if (this.queryGroupInfoTimes < 120) {
                timeCell = 1500
            } else if (this.queryGroupInfoTimes < 180) {
                timeCell = 2000
            } else if (this.queryGroupInfoTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }
            getUserGroupInfo().then((res) => {
                if (res.code === 200 && this.$Utils.isObject(res.data)) {
                    this.userGroupInfo = res.data
                    const { status, order_status } = this.userGroupInfo.latest_main || {}
                    if (status === 1 && this.orderStatus.indexOf(order_status) > -1) {
                        this.queryGroupInfoTimeTd = setTimeout(() => {
                            this.getUserGroupInfo()
                        }, timeCell)
                    }
                }
            })
        },
        // 获取vip商品列表
        getVipGoodsData() {
            getVipShopList(this.vipGoodsQuery).then((res) => {
                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                    const { is_first, list } = res.data
                    this.is_first = is_first
                    this.vipGoodsList = list.map((v) => {
                        v.showOriginPrice = false
                        try {
                            let formatChannel = JSON.parse(v.channel)
                            if (this.$Utils.isObject(formatChannel)) {
                                let priceChannel = formatChannel.price_channel
                                if (Array.isArray(priceChannel) && priceChannel.indexOf(this.channel) > -1) {
                                    v.showOriginPrice = true
                                }
                            }
                        } catch (error) {}
                        return v
                    })
                }
            })
        },
        async buy(type, item) {
            this.type = type
            this.chooseGoods = item
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.buy(type, item)
                    }
                })
            }
            // 是否实名认证过
            await this.$Utils.waitForAuthInfo()
            if (
                !canPlayGame(this, () => {
                    this.buy(type, item)
                })
            ) {
                return false
            }

            const result = await this.beforeCreateOrderJudge()
            if (!result) {
                return false
            }

            this.$BuyGroupVip.show({
                type,
                goods: this.chooseGoods
            })
        },
        // 创建订单前判断是否可以开团
        beforeCreateOrderJudge() {
            return new Promise((resolve) => {
                if (this.type === 1) {
                    resolve(true)
                    return
                }

                getUserGroupInfo()
                    .then(async (res) => {
                        if (res.code === 200 && this.$Utils.isObject(res.data)) {
                            this.userGroupInfo = res.data
                            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
                            await this.$Utils.sleep(100)
                            if (this.canCreateGroupVipOrder) {
                                resolve(true)
                            } else {
                                resolve(false)
                                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                                if ((latest_main.status === 1 && this.orderStatus.indexOf(latest_main.order_status) > -1) || (latest_join.status === 1 && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1)) {
                                    this.$Toast.show('您正有一笔拼团订单在待生效中，无法重复发起，请前往订单中心查看')
                                } else if ((latest_main.status === 2 && this.orderStatus.indexOf(latest_main.order_status) > -1) || (latest_join.status === 2 && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1)) {
                                    this.$Toast.show('您已成功拼团开通会员，无法重复发起，请前往订单中心查看')
                                }
                            }
                        } else {
                            resolve(false)
                            this.$Toast.show(res.msg || '获取拼团信息失败，请稍后再试')
                        }
                    })
                    .catch((err) => {
                        resolve(false)
                        this.$Toast.show('获取拼团信息失败，请稍后再试')
                        console.log('[beforeCreateOrderJudge]=======>', err)
                    })
            })
        },
        handlerClickShareBtn() {
            this.showShareLink = true
        },
        copyLink() {
            this.$Utils.copy(this.shareLink)
        }
    }
}
</script>

<style lang="less" scoped>
.act-group-buy-vip {
    .act-content {
        position: relative;
        top: 0;
        left: 50%;
        width: 1350px;
        transform: translateX(-50%);
        height: 100vh;
        z-index: 101;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        letter-spacing: 0px;

        .scroller {
            overflow-y: auto;
            width: 1350px;

            .whole-bg {
                margin: 0 auto;
                padding-top: 657px;
                width: 1350px;
                background: url(../../../assets/act/group-bg.png) top center no-repeat #070630;
                display: flex;
                flex-direction: column;
                align-items: center;

                &.has-group-info {
                    padding-top: 668px;
                }

                .group-info {
                    margin: 0 auto 47px;
                    width: 996px;
                    height: 305px;
                    background: url(../../../assets/act/group-info.png) center/100% no-repeat;

                    .cnt {
                        padding-top: 28px;
                        margin: 32px auto 0;
                        width: 928px;
                        height: 186px;
                        display: flex;

                        &.succ,
                        &.fail {
                            display: block;
                            padding: 0;
                            height: 239px;

                            /deep/ .goods-info {
                                position: relative;
                                top: -9px;
                                margin: 0 auto;
                            }
                        }

                        &.succ {
                            background: url(../../../assets/act/group-succ-center-bg.png) center/100% no-repeat;
                        }

                        &.fail {
                            background: url(../../../assets/act/group-succ-center-bg.png) center/100% no-repeat;
                        }

                        .user-info {
                            flex-shrink: 0;
                            width: 272px;

                            .title {
                                margin-bottom: 10px;
                                color: #683907;
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                            }

                            .price-sec {
                                color: #ea3b3b;

                                .sp1 {
                                    font-size: 12px;
                                }

                                .sp2 {
                                    margin-left: 2px;
                                    font-size: 16px;
                                    font-weight: 900;
                                }

                                .sp3 {
                                    font-size: 24px;
                                    font-weight: 900;
                                    margin-right: 5px;
                                }

                                .sp4 {
                                    color: #916e38;
                                    font-size: 14px;
                                    font-weight: 900;
                                    line-height: 17px;
                                    text-decoration-line: line-through;
                                }
                            }

                            .line {
                                position: relative;
                                left: 6px;
                                width: 266px;
                                height: 22px;
                                background: url(../../../assets/act/line.png) center/100% no-repeat;

                                .discount {
                                    position: absolute;
                                    left: 144px;
                                    width: 80px;
                                    top: -24px;
                                    text-align: center;

                                    .dv1 {
                                        color: rgb(234, 59, 59);
                                        font-size: 12px;
                                        line-height: 15px;
                                    }

                                    .dv2 {
                                        font-weight: 900;
                                        color: rgb(234, 60, 60);

                                        .i1 {
                                            font-size: 12px;
                                        }

                                        .i2 {
                                            font-size: 16px;
                                        }
                                    }
                                }
                            }

                            .countdown {
                                display: flex;
                                color: rgb(255, 255, 255);

                                .sp1 {
                                    text-align: center;
                                    line-height: 22px;
                                    font-size: 16px;
                                    width: 36px;
                                    height: 22px;
                                    background: url(../../../assets/act/countdown-icon.png) center/100% no-repeat;
                                }

                                .sp2 {
                                    width: 10px;
                                    font-size: 20px;
                                    font-weight: 900;
                                    margin-top: -4px;
                                    padding-left: 2px;
                                }

                                .sp3 {
                                    margin-left: 4px;
                                    color: rgb(145, 110, 56);
                                    font-size: 14px;
                                    line-height: 22px;
                                }
                            }
                        }

                        .invite-info {
                            padding-top: 32px;
                            display: flex;
                            flex: 1;
                            padding-left: 154px;

                            .item1,
                            .item2 {
                                img {
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    border-radius: 50%;
                                }
                            }

                            .item1 {
                                position: relative;
                                margin-right: 24px;
                                width: 60px;
                                height: 60px;
                                border: 1px solid #f8e3c2;
                                border-radius: 50%;

                                .icon {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    position: absolute;
                                    top: 48px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    width: 46px;
                                    height: 20px;
                                    border-radius: 10px;
                                    border: 1px solid #faf7f2;
                                    background: #ea3b3b;
                                    color: #ffffff;
                                    font-size: 12px;
                                }
                            }

                            .item2 {
                                width: 60px;
                                height: 60px;
                                background: url(../../../assets/act/invite-btn.png) center/100% no-repeat;
                            }
                        }

                        .group-succ,
                        .group-fail {
                            margin: 30px auto 0;

                            .text {
                                color: #331e07;
                                text-align: center;
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                            }

                            .text1 {
                                span {
                                    color: #ea3b3b;
                                }
                            }
                        }

                        .group-fail {
                            .icon {
                                position: relative;
                                top: 10px;
                                margin-right: 8px;
                                display: inline-block;
                                width: 36px;
                                height: 36px;
                                background: url(../../../assets/act/cry-icon.png) center/100% no-repeat;
                            }
                        }
                    }

                    .share-btn {
                        cursor: pointer;
                        margin: 20px auto 0;
                        width: 228px;
                        height: 53px;
                        color: #ffffff;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 53px;
                        background: url(../../../assets/act/share-btn.png) center/100% no-repeat;
                    }

                    .share-link-section {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin: 12px auto 0;
                        padding: 6px 16px 6px 14px;
                        width: 923px;
                        height: 54px;
                        border-radius: 2px;
                        border: 1px solid #f1be3f;
                        background: #fae6c5;

                        .link-dv {
                            width: 813px;
                            color: #683907;
                            font-size: 14px;
                        }

                        .copy-btn {
                            cursor: pointer;
                            color: #ffffff;
                            text-align: center;
                            font-size: 14px;
                            line-height: 30px;
                            width: 66px;
                            height: 30px;
                            flex-shrink: 0;
                            border-radius: 15px;
                            background: linear-gradient(97deg, #ffc363 -4.41%, #be3f10 74.85%);
                            box-shadow: 0 4px 10px 0 #e9c690 inset;
                        }
                    }
                }

                .vip-goods-wrap {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;

                    .item {
                        position: relative;
                        width: 300px;
                        border-radius: 12px;
                        transition: 0.3s;
                        margin-right: 45px;

                        &:last-child {
                            margin-right: 0;
                        }

                        .inner {
                            position: relative;
                            height: 157px;
                            overflow: hidden;
                        }

                        .icon {
                            position: absolute;
                            top: -27px;
                            right: -21px;
                            width: 108px;
                            height: 78px;
                            background: url(../../../assets/act/diamond-icon.png) center/100% no-repeat;
                        }

                        .dv1 {
                            padding-top: 31px;
                            text-align: center;
                            line-height: 27px;
                            font-size: 18px;
                            font-weight: 700;
                        }

                        .dv2 {
                            margin-top: 4px;
                            text-align: center;

                            .sp1 {
                                .i0 {
                                    position: relative;
                                    font-size: 12px;
                                    line-height: 18px;
                                    margin: 0 8px;
                                    top: -1px;
                                }

                                .i1 {
                                    font-size: 14px;
                                    font-weight: 700;
                                    line-height: 21px;
                                    margin-right: 4px;
                                }

                                .i2 {
                                    margin-right: 4px;
                                    font-size: 40px;
                                    font-style: normal;
                                    font-weight: 900;
                                }
                            }

                            .sp2 {
                                position: relative;
                                font-size: 12px;
                                font-weight: 400;
                                line-height: 18px;

                                i:first-child {
                                    margin-right: 4px;
                                }

                                &::after {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%);
                                    content: '';
                                    width: 105%;
                                    height: 1px;
                                }
                            }
                        }

                        .dv4 {
                            position: absolute;
                            width: 214px;
                            height: 20px;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: 18px;
                            border-radius: 4px;
                            font-size: 12px;
                            text-align: center;
                            line-height: 20px;
                        }

                        &.vip1 {
                            background: url(../../../assets/act/vip1.png) left top no-repeat;

                            .dv1 {
                                background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                                background-clip: text;
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                            }

                            .dv2 {
                                .sp1 {
                                    color: #a45d1b;
                                }

                                .sp2 {
                                    color: rgba(164, 93, 27, 0.5);

                                    &::after {
                                        background-color: rgba(164, 93, 27, 0.5);
                                    }
                                }
                            }

                            .dv4 {
                                color: rgba(164, 93, 27, 0.8);
                                border: 1px solid #e6ad5c;
                            }
                        }

                        &.vip2 {
                            background: url(../../../assets/act/vip2.png) left top no-repeat;

                            .dv1 {
                                background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                                background-clip: text;
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                            }

                            .dv2 {
                                .sp1 {
                                    color: #ffe5cd;
                                }

                                .sp2 {
                                    color: #ffe4ca;

                                    &::after {
                                        background-color: #ffe4ca;
                                    }
                                }
                            }

                            .dv4 {
                                color: #8a95b2;
                                border: 1px solid #808aa2;
                            }
                        }

                        &.vip3 {
                            background: url(../../../assets/act/vip3.png) left top no-repeat;

                            .dv1 {
                                color: rgb(119, 95, 201);
                            }

                            .dv2 {
                                .sp1 {
                                    color: #775fc9;
                                }

                                .sp2 {
                                    color: rgba(119, 95, 201, 0.5);

                                    &::after {
                                        background-color: rgba(119, 95, 201, 0.5);
                                    }
                                }
                            }

                            .dv4 {
                                color: rgba(119, 95, 201, 0.8);
                                border: 1px solid #afa6e9;
                            }
                        }

                        .buy-btn-sec {
                            margin-top: 18px;
                            display: flex;
                            justify-content: center;
                            cursor: pointer;

                            .lf-btn {
                                padding-left: 38px;
                                width: 136px;
                                height: 48px;
                                background: url(../../../assets/act/lf-btn.png) center/100% no-repeat;
                                color: #ffffff;
                                font-size: 20px;
                                font-weight: 700;
                                line-height: 48px;
                            }

                            .rg-btn {
                                position: relative;
                                padding-top: 10px;
                                margin-left: -5px;
                                padding-left: 19px;
                                width: 157px;
                                height: 48px;
                                background: url(../../../assets/act/rg-btn.png) center/100% no-repeat;

                                span {
                                    vertical-align: middle;
                                }

                                .sp1 {
                                    position: relative;
                                    top: 3px;
                                    color: #e6262c;
                                    font-size: 16px;
                                    font-weight: 400;
                                    line-height: 24px;
                                }

                                .sp2 {
                                    display: inline-block;
                                    max-width: 60px;
                                    color: #e6262c;
                                    font-size: 24px;
                                    font-weight: 700;
                                    margin-right: 8px;
                                }

                                .sp3 {
                                    position: relative;
                                    top: 3px;
                                    color: #8c7f42;
                                    font-size: 16px;
                                    font-weight: 400;
                                    line-height: 24px;
                                }

                                .right-top {
                                    position: absolute;
                                    flex-wrap: nowrap;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    top: -9px;
                                    right: 0;
                                    width: 64px;
                                    height: 22px;
                                    background: url(../../../assets/act/pop-icon.png) center/100% no-repeat;
                                    color: #ffca1b;
                                    font-size: 12px;

                                    span {
                                        max-width: 60px;
                                    }
                                }

                                .bottom-text {
                                    position: absolute;
                                    right: 0;
                                    bottom: -26px;
                                    color: #ffca1b;
                                    font-size: 16px;

                                    &.white-color {
                                        color: #ffffff;
                                    }
                                }
                            }
                        }
                    }
                }

                .activity-rules {
                    width: 1094px;
                    margin: 116px auto 113px;

                    .rules-title {
                        text-align: center;
                        color: #d3dfff;
                        font-size: 30px;
                        font-weight: 700;
                        line-height: 45px;
                    }

                    .divide-line {
                        margin: 2px auto 23px;
                        width: 400px;
                        height: 20px;
                        background: url(../../../assets/act/divide-line.png) center/100% no-repeat;
                    }

                    .rules-cnt {
                        margin-bottom: 24px;
                        color: #e8eeff;

                        .one-level {
                            margin: 0 0 12px;
                            font-size: 16px;
                            font-weight: 700;
                            line-height: 24px;
                        }

                        .two-level {
                            display: flex;
                            color: #d3dfff;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 24px;
                            margin-bottom: 8px;
                            width: 1072px;

                            .icon {
                                flex-shrink: 0;
                                margin: 7px 7px 0 5px;
                                width: 10px;
                                height: 10px;
                                margin-right: 6px;
                                background: url(../../../assets/act/square-icon.png) center/100% no-repeat;
                            }

                            .dv {
                                flex: 1;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
